import type { CSSProperties, ReactNode } from 'react';
import LiquidGlass from 'liquid-glass-react';
import { useApp } from '../app-state';
import type { GlassCapability } from '../data/ui-style';

export interface GlassSurfaceProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  padding?: string;
  radius?: number;
  frost?: number;
  bend?: number;
}

function glassUsable(capability: GlassCapability): boolean {
  return capability.translucency && !capability.reducedMotion;
}

export function GlassSurface({
  children,
  className = '',
  style,
  padding = '0px',
  radius = 20,
  frost = 10,
  bend = 38,
}: GlassSurfaceProps) {
  const { uiStyle, glass } = useApp();

  if (uiStyle !== 'glass' || !glassUsable(glass)) {
    return (
      <div className={className} style={style}>
        {children}
      </div>
    );
  }

  const surface = {
    className: `lc-glass ${className}`.trim(),
    padding,
    cornerRadius: radius,
    blurAmount: frost,
    displacementScale: glass.refraction ? bend : 0,
    saturation: 160,
    aberrationIntensity: glass.refraction ? 2 : 0,
    elasticity: 0.12,
    mode: glass.refraction ? 'standard' : 'prominent',
  } as const;

  if (style === undefined) {
    return <LiquidGlass {...surface}>{children}</LiquidGlass>;
  }

  return (
    <LiquidGlass {...surface} style={style}>
      {children}
    </LiquidGlass>
  );
}
